export const ChinaCityLang = {
  "安徽": "Anhui", 
  "北京": "Beijing", 
  "福建": "Fujian", 
  "甘肃": "Gansu", 
  "广东": "Guangdong", 
  "广西": "Guangxi", 
  "贵州": "Guizhou", 
  "海南": "Hainan", 
  "河北": "Hebei", 
  "河南": "Henan", 
  "黑龙江": "Heilongjiang", 
  "湖北": "Hubei", 
  "湖南": "Hunan", 
  "吉林": "Jilin", 
  "江苏": "Jiangsu", 
  "江西": "Jiangxi", 
  "辽宁": "Liaoning", 
  "内蒙古": "Inner Mongoria IM", 
  "宁夏": "Ningxia", 
  "青海": "Qinghai", 
  "山东": "Shandong", 
  "山西": "Shanxi", 
  "陕西": "Shaanxi", 
  "上海": "Shanghai", 
  "四川": "Sichuan", 
  "天津": "Tianjing", 
  "西藏": "Tibet", 
  "新疆": "Xinjiang", 
  "云南": "Yunnan", 
  "浙江": "Zhejiang", 
  "重庆": "Chongqing", 
  "澳门": "Macao", 
  "香港": "Hongkong ", 
  "台湾": "Taiwan"
}

const rawWorldNames = require('@/utils/worldName.json')
const worldNamesDict = {
  cn2en: {},
  en2cn: {},
}
rawWorldNames.forEach((row)=> {
  let data = row.split('-')
  worldNamesDict.cn2en[data[1]]=data[0];
  worldNamesDict.en2cn[data[0]]=data[1];
})

export {
  worldNamesDict
}